import React, { useEffect } from 'react'
import { ChromePicker } from 'react-color'

import { GlobalColorTag } from 'services/apiTypes/colorTag.types'

import ToastService from 'services/toast.service'

import Modal from 'components/elements/Modal'
import PhatButton from 'components/formElements/PhatButton'
import PhatInput from 'components/formElements/PhatInput'

import styles from './colorTagEditModal.module.scss'

type Props = {
  colorTag?: GlobalColorTag | null
  open: boolean
  onClose: () => void
  onEdit: (colorTag: GlobalColorTag) => void
  noEditName?: boolean
}

const ColorTagEditModal = ({ colorTag, open, onClose, onEdit, noEditName = false }: Props) => {
  const [name, setName] = React.useState(colorTag?.name || '')
  const [color, setColor] = React.useState(colorTag?.color || '#fa890d') // Default color - archidekt orange :kekw:

  useEffect(() => {
    if (!open) return

    setName(colorTag?.name || '')
    setColor(colorTag?.color || '#fa890d') // Default color - archidekt orange :kekw:
  }, [open])

  const handleTagCreate = (e: React.FormEvent) => {
    e.preventDefault()

    if (!name || !color)
      return ToastService.create('Tags require a valid color and name', 'Color tag creation', 'error')

    onEdit({ ...colorTag, name, color })

    // Reset fields for next time
    setName('')
    setColor('')

    onClose()
  }

  return (
    <Modal open={open} onClose={onClose} closeButton modalClassName={styles.modal}>
      <h4>Create color tag</h4>

      <form onSubmit={handleTagCreate} className={styles.form}>
        <PhatInput
          containerClassName={styles.input}
          focusOnMount
          value={name}
          onChange={setName}
          header="Tag name"
          placeholder="New tag name"
          disabled={noEditName}
        />

        <div className={styles.center}>
          <ChromePicker
            disableAlpha
            color={color}
            onChangeComplete={(color: Record<string, any>) => setColor(color.hex)}
          />
        </div>

        <div className={styles.controls}>
          <PhatButton color="green" icon={colorTag?.id ? 'save outline' : 'add'} type="submit">
            {colorTag?.id || noEditName ? 'Update' : 'Create'} color tag
          </PhatButton>
        </div>
      </form>
    </Modal>
  )
}

export default ColorTagEditModal
